import { useQuery } from '@tanstack/react-query';
import { getCustomerOrderById } from '../../api/apiStorefront';
import { useAuthContext } from '../../auth/useAuthContext';

export const useGetCustomerOrderById = (id) => {
  const { isAuthenticated } = useAuthContext();

  return useQuery({
    queryKey: ['customer-order', id],
    queryFn: async () => {
      const response = await getCustomerOrderById(id);
      return response?.data || null;
    },
    enabled: isAuthenticated && !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });
};
